<script>
import Multiselect from 'vue-multiselect';

export default {
  name: 'custom-multiselect',
  components: {
    Multiselect,
  },
  props: {
    name: String,
    disabled: Boolean,
    options: {
      type: Array,
      default: [],
    },
    isValid: Boolean,
    fieldName: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Object],
    },
    defaultValue: [String, Object],
    'data-vv-value': String,
    'data-vv-name': String,
    'track-by': String,
  },
  mounted() {
    if (this.defaultValue !== undefined && this.defaultValue !== null) {
      this.$emit(
        'input',
        typeof this.defaultValue === 'object' ? { ...this.defaultValue } : this.defaultValue
      );
    }
  },
  render(h) {
    const self = this;

    return h(Multiselect, {
      attrs: this.$attrs,
      props: {
        ...this.$props,
        'custom-label': data => {
          if (typeof data === 'string') {
            return data;
          }

          if (!this.$props.fieldName) {
            /* eslint-disable no-console */
            console.error('Multiselect must have a fieldName props');
          }

          return data[this.$props.fieldName];
        },
      },
      class: {
        'error-multiselect': !this.$props.isValid,
      },
      on: {
        input: function(selectItem) {
          self.$emit('input', selectItem);
        },
      },
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .error-multiselect .multiselect__tags {
    border: 1px solid #dc3545;
    border-radius: 5px;
  }
  .multiselect {
    padding: 0;
    min-width: 300px;
  }
  .multiselect.form-control {
    display: block;
  }
  .form-inline .multiselect.form-control {
    display: inline-block;
  }
  .multiselect__tags {
    min-height: unset;
    padding: 10px 40px 0 6px;
    border: none;
  }
  .multiselect__select {
     width: auto;
  }
  .multiselect__content-wrapper {
    margin-top: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/components/CustomMultiselect.vue